import hash from "../utility/hash"
import sjcl from "sjcl"

const p = hash("123456", "pass")

const decrypt = (pass) => {
    try {
        return sjcl.decrypt(p, pass)
    } catch(e) {
        return null
    }
}

const encrypt = (pass) => sjcl.encrypt(p, pass)

const getMasterPassword = () => {
    if (window.localStorage) {
        const masterPassword = window.localStorage.getItem("singular-key-pass")
        if (masterPassword === undefined || masterPassword === null) {
            return null
        }
        return decrypt(masterPassword)
    }
    return null;
}

const setMasterPassword = (password) => {
    if (window.localStorage) {
        if (password === null || password === '') {
            window.localStorage.removeItem("singular-key-pass")
        } else {
            window.localStorage.setItem("singular-key-pass", encrypt(password))
        }
    }
}


export default (...args) => (args.length == 0) ? getMasterPassword() : setMasterPassword(args[0])
